var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_5760_5212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5760_5212",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5760_5212",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5760_5212",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABnUlEQVR4nO2XPUtDMRSGI0I3h4KIIIiD4OQvUEfRRXASXdxcXAQXFzcX0cXYQqu2XPyoQ630Q0FFHEQFQVCQYrGWNv/klesZ6sVWK5ckrZ4XDuSEM5zn5s1NIgSLpVeQAlpiQ6y2LsBOlzkI6AAoxIFYtxkILQAqZw4CugBMQUAngDIAoR1AaYYwAqA0QhgDUJogjAIoDRDGAZQXojkBfhGCASSvANhCfsQWkmwhf/rbFno7rB2ZUcDppfHjGtWeTnpr8lHgchYIBSwCPKx4o5Klq0BiEHD6aPwcotqzKcpfYlRbcCi/nm+Skzg1Qg3dL1NeD8D96m6+FQTKaaCSBjbbLQOEA3QBc5uJ9zQG4MbrAc1Fg5YBzqepkau56lw9gJsFYLcfyIxTXtwHZJtFgO1OoJQEigkg0vEzwOcoHwOpYct74HaRmjmZ8M7XA3haJxtlx6oPF2sAewOAygL5yNeN2MgekLbPAfcf/9FkGLhbqsbRUIsAlJK1n4QXMy0CIPWHYADJKwC2kB+xhSRbyJ/YQpIt9M8txGKJb/UOJFOCiMRgcS0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/Zip.c76d8b9cb8e918683ffd71a839fa7421.svg";
export { ForwardRef as ReactComponent };